import { createSelector } from 'reselect';
import { getVisibility } from 'conversations-internal-schema/inbox/operators/inboxGetters';
import { getCurrentInbox } from './getCurrentInbox';
export const getCurrentInboxVisibility = createSelector([getCurrentInbox], getVisibility);